(() => {
  // src/tabbed-carousel.ts
  (() => {
    const activateTab = (container, index) => {
      const tabs = Array.from(container.querySelectorAll(".tabbed-carousel__tabs button"));
      const panels = Array.from(container.querySelectorAll(".tabbed-carousel__panel"));
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle("is-active", active);
        tab.classList.toggle("button--unselected", !active);
        tab.setAttribute("aria-selected", String(active));
      });
      panels.forEach((panel, i) => panel.classList.toggle("is-active", i === index));
      container.dataset.activeTab = String(index);
    };
    document.addEventListener("click", (e) => {
      const tab = e.target.closest(".tabbed-carousel__tabs button");
      if (!tab) return;
      const container = tab.closest(".tabbed-carousel");
      if (!container) return;
      const tabs = Array.from(container.querySelectorAll(".tabbed-carousel__tabs button"));
      activateTab(container, tabs.indexOf(tab));
    });
    document.addEventListener("shopify:section:load", (e) => {
      e.target.querySelectorAll(".tabbed-carousel[data-active-tab]").forEach((container) => {
        activateTab(container, Number(container.dataset.activeTab));
      });
    });
  })();
})();
